// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"700c7581","769":"af6788b5"}[chunkId] + ".chunk.js";
};